import { DialogComponent } from '@theme/dialog';

/**
 * Opens the Shop the Look drawer from `#shop-the-look` links.
 *
 * Athos renders collection banners client-side, so they can't carry the block's own trigger
 * button. A banner links to `#shop-the-look` instead. Athos keeps its filter state in the URL hash
 * (`#/filter:...`), so following that link would wipe the shopper's filters: the click is always
 * cancelled, and the drawer opens if one is on the page.
 *
 * One capturing listener on `document` handles links rendered at any time, including after Athos
 * re-renders on filter, sort and page changes, and runs before any Athos handler can stop the
 * event. The drawer rendered for Athos (`[data-shop-the-look-link-target]`, main-collection) wins;
 * otherwise the first drawer on the page opens.
 */

const LINK_HASH = '#shop-the-look';
const DRAWER_SELECTOR = 'dialog-component.shop-the-look';
const PREFERRED_DRAWER_SELECTOR = `[data-shop-the-look-link-target] ${DRAWER_SELECTOR}`;

/**
 * A link to `#shop-the-look` on the current page, relative or absolute.
 *
 * @param {EventTarget} node
 * @returns {node is HTMLAnchorElement}
 */
function isShopTheLookLink(node) {
  return (
    node instanceof HTMLAnchorElement &&
    node.hash === LINK_HASH &&
    node.origin === window.location.origin &&
    node.pathname === window.location.pathname
  );
}

/** @returns {DialogComponent | undefined} */
function findDrawer() {
  const drawer = document.querySelector(PREFERRED_DRAWER_SELECTOR) ?? document.querySelector(DRAWER_SELECTOR);
  return drawer instanceof DialogComponent ? drawer : undefined;
}

document.addEventListener(
  'click',
  (event) => {
    console.log(event)
    if (event.defaultPrevented || !event.composedPath().some(isShopTheLookLink)) return;

    event.preventDefault();
    findDrawer()?.showDialog();
  },
  { capture: true }
);
